module.exports = __webpack_public_path__ + "img/icon_system_terminal.65dc4c67.svg";